import { Contact } from '../../contacts/types'
import { FormValue, Pagination } from '../../globalTypes'
import { ProjectItem } from '../../projects/types'
import { Property } from '../../properties/types'

export interface ActivityAgent {
    agent: {
        id: number
        firstName: string
        lastName: string
        agencyOffice: {
            id: number
        }
    }
    notificationSend: number
}

export interface ActivityReminder {
    id?: number
    channel: string
    reminderMinutesBefore: number
}

export interface ActivityType {
    activityCategory: FormValue
    color: string
    id: number
    name: string
    visibility: number
}

export enum ActivityCategory {
    Event = 1,
    Task = 2,
    Reminder = 3,
}

export interface Activity {
    activityAgent: ActivityAgent[]
    activityReminder: ActivityReminder[]
    activityType: ActivityType
    completed: boolean
    contact: Contact
    contactCompany: Contact[]
    created: string
    dateFrom: string
    dateTo: string
    durationDay: boolean | number
    id: number
    location: string | null
    notes: string | null
    project: ProjectItem[]
    property: Property[]
    source: 'system' | 'user'
    timeFrom: string
    timeTo: string
    title: string
    updated: string
}

export interface ActivityCriteria {
    activityType?: string[]
    agent?: string[]
    rangeFrom?: string
    rangeTo?: string
    source?: string
    contact?: number
}

export interface ActivityListResponse {
    count: number
    items: Activity[]
    pagination: Pagination
}

export interface ActivityDeleteParams {
    id: number
}

export interface ActivityDeleteResponse {
    id: number
}

export interface ActivityMutationResponse {
    id: number
}

export interface ActivityValuesData {
    type: ActivityType[]
    [key: string]: (FormValue | ActivityType)[] | undefined
}
